import {axiosInstance} from "../utils/axios";

export const createClassPlan = ({classPlanData, classID}) => {
    return axiosInstance.post(`/teachers/virtual-class/${classID}/class-plan`, classPlanData);
}

export const addItemsToClass = ({classPlanID, classPlanItems}) => {
    return axiosInstance.post(`teachers/class-plan/${classPlanID}/update-items`, classPlanItems);
}

export const getClassPlan = (classID) => {
    return axiosInstance.get(`teachers/class-plans/${classID}`);
}

export const removeClassPlanItem = (rowContentId) => {
    return axiosInstance.delete(`teachers/class-plan-items/${rowContentId}`);
}

